module.exports = __webpack_public_path__ + "static/media/Template_26.9c2fef56.png";